<template>
  <div :class="{'table-hidden' : !isTableVisible}">
    <h2>{{this.componentid}}</h2>
    <p class="main-intro-text">Der Darstellung liegen derzeit die für die IfL-Direktstudierenden erfassten Daten aus den ausgewerteten Lexika sowie Basisdaten zu Lebensdaten und Studienzeiten am IfL zugrunde; Daten aus weiteren genutzten Quellen werden unter Berücksichtigung der Datenschutzbestimmungen ab Herbst 2024 zugänglich sein. Für nähere Informationen zum Projekt siehe: <a target="_blank" href="https://www.ddr-literatur.de">www.ddr-literatur.de</a>
    </p>
    <!--// TODO: add if condition if this.compentid contains '-1' then split before -1 
    // Warning: take in consideration the number after 10
    // Vielleicht eine Overviewliste/ geöffnete/verwendete Overviews für Publications und Events
    

    // TODO: ADD if condition if filterState is not empty, then show Filterüberblick-->
    <div class="filter-and-charts-container" :class="this.componentid">

      <label class="loading-label">Daten werden geladen...</label>

      <div class="filter-overview-container">
        <div id="filter-overview-title" style="display:flex">  
                
<!--          <h3 style="margin-top: 2px;">Filterüberblick</h3>-->
<!--          <span id="infoButton-filter-overview"></span>-->
        </div>

        <div class="filter-container">
        <div class="filter-section">
          <div class="filter-card-title" v-if="this.externalFilters.length > 0"> 
          <h4 class="filter-head" style="display:inline-block">Filter aus anderen Tabs</h4>
          <span id="infoButton-externalfilter">
              <button @click="toggleInfo" type="button"  class="chartInfoIcon">&#9432;</button>
              <span v-if="isInfoVisible" class="chartInfoText" style="width:25em">Die externen Filter zeigen die ausgewählten Filter aus anderen Tabs an.</span>
          </span>
        </div>
          <div ref="externalFiltersRoot" />

        </div>
        <div class="filter-section" >
          <div class="local-filter-card-title"  v-if="Object.keys(this.localFilterState).length > 0">
            <h4 class="filter-head" style="display:inline-block">Lokale Filter</h4>
            <div class="btn-active-filter-number" v-if="Object.keys(this.localFilterState).length > 0">{{countActiveFilter(this.localFilterState)}}</div>
            <span id="infoButton-localfilter">
              <button @click="toggleInfo" type="button" class="chartInfoIcon">&#9432;</button>
              <span v-if="isInfoVisible" class="chartInfoText">Die lokalen Filter zeigen die ausgewählten Filter des aktuellen Tabs an.</span>
            </span>
          </div>
          <div ref="localFiltersRoot"/>
        </div>
      </div>
    </div>

    <div ref="chartsRoot" class="chart-container">
      <div style="display:flex">
<!--        <h3>Daten</h3>-->
        <div class="active-persons">Ausgewählte Personen: {{currentActivePersons.size }}</div>
      </div>

      <div><button class="btn-show-chart" v-for="chartId in chartOrder" v-bind:key="chartId" v-html="chartTitles[chartId]"
          @click="showOrRemoveChartInView(chartId)" :class="{ active: isOpen(chartId) }"></button>
       
<!--        <button @click="toggleTableVisibility" class="btn-show-chart" :class="{active: isTableVisible}">-->
<!--          {{ isTableVisible ? 'Personen-Tabelle ausblenden' : 'Personen-Tabelle' }}-->
<!--        </button>-->
      </div>
      <div class="break"></div>

      <div class="flex-chart-container-events" :class="this.componentid">
        <!--        <div v-for="chartId in Object.keys(chartIsOpen).filter(key => chartIsOpen[key])" v-bind:key="chartId">

        &lt;!&ndash;
                  <div class="singleChart" v-if="chartId == 'repository-charts'" :open="isOpen(chartId)">
                    <div class="bundleChartTitle" v-html="chartTitlesExtended[chartId]" id='repository-charts'/>
                    <div :id="'chartInfoButton-' + chartId"></div>
                    <div>
                      <button class="bundleChartsBtn" :class="{ active: repositoryChartShown === 'repository-1' }" @click="showRepositoryChart('repository-1')">Quellenarten</button>
                      <button class="bundleChartsBtn" :class="{ active: repositoryChartShown === 'repository-2' }" @click="showRepositoryChart('repository-2')">Quellen</button>
                      <button class="bundleChartsBtn" :class="{ active: repositoryChartShown === 'repository-3' }" @click="showRepositoryChart('repository-3')">Personeneinträge</button>
                    </div>

                  <div id="repository-1" v-show="repositoryChartShown === 'repository-1'">
                    <div id="repotypes1-by-events-container" class="chart-container"></div>
                    <div class="chart-title">{{ subtitlesForCollectionCharts['repository-1'] }}</div>
                  </div>

                    <div id="repository-2" v-show="repositoryChartShown === 'repository-2'">
                      <div id="repotypes2-by-events-container" class="chart-container"></div>
                      <div class="chart-title">{{ subtitlesForCollectionCharts['repository-2'] }}</div>
                    </div>

                    <div id="repository-3" v-show="repositoryChartShown === 'repository-3'">
                      <div id="repotypes3-by-events-container" class="chart-container"></div>
                      <div class="chart-title">{{ subtitlesForCollectionCharts['repository-3'] }}</div>
                    </div>
                  </div>

                  <div class="singleChart" v-if="chartId == 'professions-charts'" :open="isOpen(chartId)">
                    <div class="bundleChartTitle" v-html="chartTitlesExtended[chartId]" id='professions-charts'/>
                    <div :id="'chartInfoButton-' + chartId"></div>
                    <div>
                      <button class="bundleChartsBtn" :class="{ active: professionChartShown === 'profession-1' }" @click="showProfessionChart('profession-1')">Qualifikationsniveaus</button>
                      <button class="bundleChartsBtn" :class="{ active: professionChartShown === 'profession-2' }" @click="showProfessionChart('profession-2')">Tätigkeitsfelder</button>
                      <button class="bundleChartsBtn" :class="{ active: professionChartShown === 'profession-3' }" @click="showProfessionChart('profession-3')">Berufsbezeichnungen</button>
                    </div>
                    <div id="profession-1" v-show="professionChartShown === 'profession-1'">
                      <div id="profession1-container" class="chart-container"></div>
                      <div class="chart-title">{{ subtitlesForCollectionCharts['profession-1'] }}</div>
                    </div>
                    <div id="profession-2" v-show="professionChartShown === 'profession-2'">
                      <div id="profession2-container" class="chart-container"></div>
                      <div class="chart-title">{{ subtitlesForCollectionCharts['profession-2'] }}</div>
                    </div>
                    <div id="profession-3" v-show="professionChartShown === 'profession-3'">
                      <div id="profession3-container" class="chart-container"></div>
                      <div class="chart-title">{{ subtitlesForCollectionCharts['profession-3'] }}</div>
                    </div>
                  </div>


                  &lt;!&ndash; text charts for proffesions &ndash;&gt;
                  <div class="singleChart" v-if="chartId == 'professions-textcharts'" :open="isOpen(chartId)">
                    <div class="bundleChartTitle" v-html="chartTitlesExtended[chartId]" id='professions-textcharts'/>
                    <div :id="'chartInfoButton-' + chartId"></div>
                    <div>
                      <button class="bundleChartsBtn" :class="{ active: professionChartShownTextchart === 'profession-textchart-1' }" @click="showProfessionChartTextchart('profession-textchart-1')">Qualifikationsniveaus</button>
                      <button class="bundleChartsBtn" :class="{ active: professionChartShownTextchart === 'profession-textchart-2' }" @click="showProfessionChartTextchart('profession-textchart-2')">Tätigkeitsfelder</button>
                      <button class="bundleChartsBtn" :class="{ active: professionChartShownTextchart === 'profession-textchart-3' }" @click="showProfessionChartTextchart('profession-textchart-3')">Berufsbezeichnungen</button>
                    </div>
                    <div id="profession-textchart-1" v-show="professionChartShownTextchart === 'profession-textchart-1'">
                      <div id="profession1-textchart-container" class="chart-container"></div>
                      <div class="chart-title">{{ subtitlesForCollectionCharts['profession-textchart-1'] }}</div>
                    </div>
                    <div id="profession-textchart-2" v-show="professionChartShownTextchart === 'profession-textchart-2'">
                      <div id="profession2-textchart-container" class="chart-container"></div>
                      <div class="chart-title">{{ subtitlesForCollectionCharts['profession-textchart-2'] }}</div>
                    </div>
                    <div id="profession-textchart-3" v-show="professionChartShownTextchart === 'profession-textchart-3'">
                      <div id="profession3-textchart-container" class="chart-container"></div>
                      <div class="chart-title">{{ subtitlesForCollectionCharts['profession-textchart-3'] }}</div>
                    </div>
                  </div>

                  <div class="singleChart" v-if="chartId == 'institutions-charts'" :open="isOpen(chartId)">
                    <div :id="'chartInfoButton-' + chartId"></div>
                    <div class="bundleChartTitle" v-html="chartTitlesExtended[chartId]" id='institutions-charts'/>
                    <div>
                      <button class="bundleChartsBtn" :class="{ active: institutionChartShown === 'institution-1' }" @click="shownInstitutionChart('institution-1')">Institutionstypen</button>
                      <button class="bundleChartsBtn" :class="{ active: institutionChartShown === 'institution-2' }" @click="shownInstitutionChart('institution-2')">Institutionsuntertypen</button>
                      <button class="bundleChartsBtn" :class="{ active: institutionChartShown === 'institution-3' }" @click="shownInstitutionChart('institution-3')">Institutionen</button>
                    </div>
                    <div id="institution-1" v-show="institutionChartShown === 'institution-1'">
                      <div id="institution1-container" class="chart-container"></div>
                      <div class="chart-title">{{ subtitlesForCollectionCharts['institution-1'] }}</div>
                    </div>
                      <div id="institution-2" v-show="institutionChartShown === 'institution-2'">
                        <div id="institution2-container" class="chart-container"></div>
                        <div class="chart-title">{{ subtitlesForCollectionCharts['institution-1'] }}</div>
                    </div>
                    <div id="institution-3" v-show="institutionChartShown === 'institution-3'">
                      <div id="institution3-container" class="chart-container"></div>
                      <div class="chart-title">{{ subtitlesForCollectionCharts['institution-3'] }}</div>
                    </div>
                  </div>
        &ndash;&gt;


                  <div class='singleChart' v-if="chartId !== 'repository-charts' && chartId !== 'professions-charts' && chartId !== 'professions-textcharts' && chartId !== 'institutions-charts'" :open="isOpen(chartId)">
                    <div :id="'chartInfoButton-' + chartId"></div>
                    <div v-html="chartTitlesExtended[chartId]"></div>
                    <div :id="chartId" />
                </div>
                </div>-->
      </div>
    </div>
  </div>

    <!-- Table Section, visible based on isTableVisible -->
  <div v-show="true" ref="tableRoot" class="table-container-events">
    <div class="table-controls">
    <div class="table-search">
          <label class="table-label-input" for="searchInput">Suche:</label>
          <input id="searchInput" type="text" v-model="searchTerm">
    </div>
    <!-- Download Button -->
    <div class="table-download-controls">
      <button @click="confirmDownload" class="table-download" data-title="Download data"><i class="fa fa-download"></i></button>
    </div>
    </div>
    <!-- Column Visibility Toggle as Bubbles-->
    <div class="table-column-controls">
      <div>
    <span
        v-for="(header, index) in tableHeaders"
        :key="index"
        @click="toggleColumnVisibility(header.value)"
        :class="['column-bubble', { active: columnVisibility[header.value] }]"
    >
      {{ header.text }}
    </span>
      </div>
    </div>




    <!-- EasyDataTable -->
    <EasyDataTable ref="easyDataTable" buttons-pagination alternating multi-sort :headers="filteredTableHeaders"
      :items="filteredTableData" :items-per-page="itemsPerPage" :sort-by="sortBy" :sort-type="sortType"
      v-model:page="currentPage">
    </EasyDataTable>
  </div>
  </div>
</template>

<script>

import * as dc from 'dc';
import * as d3 from 'd3';
import * as dcleaflet from 'dc.leaflet'
import crossfilter from 'crossfilter2';
import 'leaflet/dist/leaflet.css'; // Import Leaflet CSS
import L from 'leaflet';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster';
import './css/dc.css';
import './css/main.css';
import * as DEPLOYMENT from "@/lib/DeploymentConfiguration";
import * as effunctions from "@/lib/SharedExternalFiltersFunctions"
import * as charts from "@/lib/SharedChartCreators"
import { EventBus } from '../lib/EventBus';
import EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import {confirmDownload, convertToCSV, downloadTableAsCSV, filterTableData} from "@/lib/SharedFunctions";
import {
  MODE_CHECKBOX,
  MODE_TEXTINPUT_AUTOCOMPLETE,
  MODE_TEXTINPUT_DROPDOWN_SELECT,
  MODE_TEXTINPUT_TIME_INTERVAL,
  TextChart
} from "@/lib/TextChart";
import {globalEventslog} from "@/lib/GlobalEventsLog";

let instancecount = 0;

/* eslint-disable no-unused-vars */
export default {
  name: 'EventsView',
  components: {
    EasyDataTable,
  },
  data() {
    return {
      cf: null,
      mycharts: [],
      numberOfActiveFilter: this.localFilterState ? Object.values(this.localFilterState).filter(value => value.size > 0).length : 0,
      // professionChartShown: 'profession-1',
      // professionChartShownTextchart: 'profession-textchart-1',
      // institutionChartShown: 'institution-1',
      // repositoryChartShown: 'repository-1',
      markers: null,
      allEvents: [],
      pendingFilteredPersonsFromPublication: null,
      externalFilterApplied: false,
      isTableVisible: false,
      isInfoVisible: false,

      chartGroup: dc.constants.DEFAULT_CHART_GROUP,

      tableData: [],
      searchReasults: null,
      searchTerm: '',
      currentPage: 1,
      itemsPerPage: 15,
      tableHeaders: [
      { text: 'Autor*in', value: 'protagonistLabel', sortable: true },
      { text: 'Gender', value: 'protagonistGender', sortable: true },
      { text: 'Ereignistyp', value: 'type', sortable: true },
      //  { text: 'ID', value: 'id', sortable: true },
      { text: 'Datum', value: 'begin', sortable: true },
      //  { text: 'End', value: 'end', sortable: true },
      { text: 'Ort', value: 'placeLabel', sortable: true },
       // at some moment, the misleading name of this attribute ('literariyActivity') should be
       // changed on the side of the backend
        { text: 'Institution', value: 'institutionLabel' },
        { text: 'Inst. Typ (1)', value: 'institutionTypeLv1' },
        { text: 'Inst. Typ (2)', value: 'institutionTypeLv2' },
       { text: 'Bezeichnung', value: 'literariyActivity', sortable: true },
       { text: 'Berufsfeld (1)', value: 'baLvl1' },
       { text: 'Berufsfeld (2)', value: 'baLvl2' },
       { text: 'Berufsfeld (3)', value: 'baLvl3' },
       { text: 'Berufsfeld (4)', value: 'baLvl4' },
       { text: 'Qualifikation', value: 'qualificationLvl' },
        { text: 'Quellenart', value: 'repotype' },
        { text: 'Quelle', value: 'reponame' }
      ],
      // Track visibility of each column
      columnVisibility: {
        protagonistLabel: true,
        begin: true,
        protagonistGender: true,
        type: true,
        placeLabel: true,
        institutionLabel: false,
        literariyActivity: true,
        baLvl1: false,
        baLvl2: false,
        baLvl3: false,
        baLvl4: false,
        qualificationLvl: false,
        institutionTypeLv1: false,
        institutionTypeLv2: false,
        repotype: false,
        reponame: false
      },
      sortBy: [],
      sortType: ["asc", "desc"],
      chartOrder: [
        //'piechart-for-events',
        //'timeline-container-events',
        //'chart-gender',

        // 'professions-charts',
        // 'institutions-charts',
        // 'repository-charts',
        //'map-container',
        //'barchart-events-person',

         // text charts
        'chart-repository-3',
        'checkbox-chart-gender',
        'dropdown-for-events',
        'timeinterval-for-events',
        'autocomplete-for-places',
        'chart-institution-3',
        'autocomplete-chart-literaryActivity',
        'chart-profession-3',
        'chart-profession-1',

        //'professions-textcharts',

          // new single charts
        'chart-repository-1',
        'chart-repository-2',
        //'chart-repository-3',
        // 'chart-profession-2',
        // 'chart-institution-1',
        // 'chart-institution-2',
      ],
      chartTitles: {
        'piechart-for-events': 'Biographische Ereignisse',
        'chart-gender': 'Gender',
        'repository-charts': 'Quellen',
        'barchart-events-person': 'Personen',
        'professions-charts': 'Berufe',
        'institutions-charts': 'Institutionen',
        'timeline-container-events': 'Timeline',
        'map-container': 'Orte',
        'autocomplete-chart-literaryActivity': 'Bezeichnungen (Berufe, Auszeichnungen etc.)',

        // text charts
        'dropdown-for-events': 'Ereignistypen',
        'timeinterval-for-events': 'Datum',
        'checkbox-chart-gender': 'Gender',
        'autocomplete-for-places': 'Orte',
        //'professions-textcharts': 'Berufe(Textchart)',

        // new single charts
        'chart-repository-1': 'Quellentypen',
        'chart-repository-2': 'Quellennamen',
        'chart-repository-3': 'Autor*innen',
        'chart-profession-1': 'Qualifikationsniveaus',
        'chart-profession-2': 'Tätigkeitsfelder',
        'chart-profession-3': 'Berufsfelder (1)',
        'chart-institution-1': 'Institutionstypen',
        'chart-institution-2': 'Institutionsuntertypen',
        'chart-institution-3': 'Institutionen',

      },
      // renamed to expanded, it was extended
      chartTitlesExtended: {
        'chart-gender': 'Gender (Personenanzahl)',
        'repository-charts': 'Quellen',
        'piechart-for-events': 'Ereignistypen nach Ereignisanzahl',
        'barchart-events-person': 'Personen (Top 15 nach Ereignisanzahl)',
        'professions-charts': 'Berufe',
        'institutions-charts': 'Institutionen (Personenanzahl)',
        'timeline-container-events': 'Timeline nach Ereignisanzahl',
        'map-container': 'Orte',
        // text charts
        'dropdown-for-events': 'Ereignistypen (Personenanzahl)',
        'timeinterval-for-events': 'Datum',
        'checkbox-chart-gender': 'Gender (Personenanzahl)',
        'autocomplete-for-places': 'Orte (Personenanzahl)',
        //'professions-textcharts': 'Berufe(Textchart)',
        'autocomplete-chart-literaryActivity': 'Bezeichnung (Personenanzahl)',

        // new single charts
        'chart-repository-1': 'Quellentypen (Personenanzahl)',
        'chart-repository-2': 'Quellen (Personenanzahl)',
        'chart-repository-3': 'Autor*innen (Ereignisanzahl)',
        'chart-profession-1': 'Qualifikationsniveaus (Personenanzahl)',
        'chart-profession-2': 'Tätigkeitsfelder',
        'chart-profession-3': 'Berufsfelder (1) (Personenanzahl)',
        'chart-institution-1': 'Institutionstypen',
        'chart-institution-2': 'Institutionsuntertypen',
        'chart-institution-3': 'Institutionen (Personenanzahl)',

      },
      chartIsOpen: {
        'piechart-for-events': false,
        'timeline-container-events': false,
        'chart-gender': false,
        'professions-charts': false,
        'institutions-charts': false,
        'map-container': false,
        'barchart-events-person': false,
        'repository-charts': false,

        //text charts
        'chart-repository-3': true,
        'checkbox-chart-gender': true,
        'dropdown-for-events': true,
        'timeinterval-for-events': true,
        'autocomplete-for-places': true,
        'autocomplete-chart-literaryActivity': true,

        //'professions-textcharts': false,

        // new single charts
        'chart-repository-1': false,
        'chart-repository-2': false,
        //'chart-repository-3': true,
        'chart-profession-1': false,
        'chart-profession-2': false,
        'chart-profession-3': false,
        'chart-institution-1': false,
        'chart-institution-2': false,
        'chart-institution-3': false,
      },
      filterAttributeToFilterState : {
        'Gender': 'personsByGender',
        'Ereignistypen': 'eventByEvents',
        'Tätigkeitsfelder ': 'professionsEvaluationAreas',
        'Qualifikationsniveaus': 'professionsEvaluationProfessions',
        'Berufe': 'professionsEvaluationByPersons',
        'Institutionstypen': 'institutionsEvaluationTypes',
        'Institutionsuntertypen': 'institutionsEvaluationSubtypes',
        'Institutionen': 'institutionsEvaluationByPersons',
        'Quellentypen': 'referencesEvaluationRepositoryTypes',
        'Quellennamen': 'referencesEvaluationRepositoryNames',
        'Personeneinträge (Quellen)': 'referencesEvaluationPersons',
        'Timeline (Biographien)': 'timelineByNumberOfEvents',
        'Personen': 'eventsForPersons',

        //text charts
        'Ereignistypen(Textchart)': 'eventTypeDropdown',
        'Timeinterval (Biographien)': 'timeintervalByNumberOfEvents',
        'Gender(Textchart)': 'personsByGenderTextchart',
        'Place(Textchart)': 'placesByPersonenTextchart',
        'Bezeichnung(Textchart)': 'literaryActivityFilter',
        //'Tätigkeitsfelder (Textchart)': 'professionsEvaluationAreasTextchart',
        //'Qualifikationsniveaus (Textchart)': 'professionsEvaluationProfessionsTextchart',
        //'Berufe (Textchart)': 'professionsEvaluationByPersonsTextchart',

        // new single charts
        'Quellenarten_2': 'referencesEvaluationRepositoryTypesForTextChart',
        'Quellen_2': 'referencesEvaluationRepositoryNamesForTextChart',
        'Personeneinträge_2': 'referencesEvaluationPersonsForTextChart',
        'Qualifikationsniveaus_2': 'professionsEvaluationProfessionsForTextChart',
        'Tätigkeitsfelder_2': 'professionsEvaluationAreasForTextChart',
        'Berufsbezeichnungen_2': 'professionsEvaluationByPersonsForTextChart',
        'Institutionstypen_2': 'institutionsEvaluationTypesForTextChart',
        'Institutionsuntertypen_2': 'institutionsEvaluationSubtypesForTextChart',
        'Institutionen_2': 'institutionsEvaluationByPersonsForTextChart',


      },
    filterStateToChartRegisterAnchor : {
      'personsByGender': 'chart-gender',
      'eventByEvents': 'piechart-for-events',
      'eventsForPersons': 'barchart-events-person',
      'institutionsEvaluation': ['inst-lv1-container', 'inst-lv2-container', 'inst-names-container' ],
      'professionsEvaluation': ['ba-quallvl-container', 'ba-lvl1-container', 'ba-lvl4-container' ],
      'referencesEvaluation': ['repotypes-by-events-container', 'reponames-by-events-container', 'persons-by-reponames-container'],
      'timelineByNumberOfEvents': 'timeline-container-events',

      // text charts
      'eventTypeDropdown': 'dropdown-for-events',
      'timeintervalByNumberOfEvents': 'timeinterval-for-events',
      'personsByGenderTextchart': 'checkbox-chart-gender',
      'placesByPersonenTextchart': 'autocomplete-for-places',
      'literaryActivityFilter': 'autocomplete-chart-literaryActivity',
      //'professionsEvaluationProfessionsTextchart': 'professions-textcharts',
      //'professionsEvaluationByPersonsTextchart': 'profession-textchart-3',
      //'professionsEvaluationTextchart': ['profession-textchart-1', 'profession-textchart-2', 'profession-textchart-3' ],


      // new single charts
      'referencesEvaluationRepositoryTypesForTextChart': 'chart-repository-1',
      'referencesEvaluationRepositoryNamesForTextChart': 'chart-repository-2',
      'referencesEvaluationPersonsForTextChart': 'chart-repository-3',
      'professionsEvaluationProfessionsForTextChart': 'chart-profession-1',
      'professionsEvaluationAreasForTextChart': 'chart-profession-2',
      'professionsEvaluationByPersonsForTextChart': 'chart-profession-3',
      'institutionsEvaluationTypesForTextChart': 'chart-institution-1',
      'institutionsEvaluationSubtypesForTextChart': 'chart-institution-2',
      'institutionsEvaluationByPersonsForTextChart': 'chart-institution-3',
      },
      subtitlesForCollectionCharts: {
        'repository-1': 'Quellentypen nach Ereignisanzahl',
        'repository-2': 'Quellen nach Ereignisanzahl',
        'repository-3': 'Personen nach Anzahl von Quellen (Top 15)',
        'profession-1': 'Qualifikationsniveaus nach Personenanzahl',
        'profession-2': 'Tätigkeitsfelder nach Personenanzahl',
        'profession-3': 'Berufe nach Personenanzahl',
        'institution-1': 'Institutionstypen nach Personenanzahl',
        'institution-2': 'Institutionsuntertypen nach Personenanzahl',
        'institution-3': 'Institutionen nach Personenanzahl',

        //text charts
        'profession-textcharts-1': 'Qualifikationsniveaus nach Personenanzahl',
        'profession-textcharts-2': 'Tätigkeitsfelder nach Personenanzahl',
        'profession-textcharts-3': 'Berufe nach Personenanzahl',
      },
      chartsVisibility: {
        'piechart-for-events': {
          creatorfunc: () => this.createPieChartForEvents(),
        },
        'chart-gender': {
          creatorfunc: () => this.createBarChartForGender(),
        },
        'barchart-events-person': {
          creatorfunc: () => this.createBarChartEventsForPersons(),
        },
        /*'repository-charts': {
          // the creator functions need to return the chart object in order for toggleChart() to work
          creatorfunc: () => this.createChartsForReferences(),
        },
        'professions-charts': {
          creatorfunc: () => this.createChartsForProfessionsEvaluation(),
        },
        'institutions-charts': {
          creatorfunc: () => this.createChartsForInstitutions(),
        },*/
        'timeline-container-events': {
          creatorfunc: () => this.createTimelineChartFromEventsWithEventCount(),
        },

        // text charts
        'dropdown-for-events': {
          creatorfunc: () => this.createDropdownChartForEvents(),
        },
        'timeinterval-for-events': {
          creatorfunc: () => this.createTimeIntervalChartForTimeline(),
        },
        'checkbox-chart-gender': {
          creatorfunc: () => this.createGenderCheckboxChart(),
        },
        'autocomplete-for-places': {
          creatorfunc: () => this.createAutocompleteChartForPlaces(),
        },
        'autocomplete-chart-literaryActivity': {
          creatorfunc: () => this.createAutocompleteChartForLiteraryActivity(),
        },

        // new single charts
        'chart-repository-1': {
          creatorfunc: () => this.createRepositoryTypeChart(),
        },
        'chart-repository-2': {
          creatorfunc: () => this.createRepositoryNameChart(),
        },
        'chart-repository-3': {
          creatorfunc: () => this.createRepositoryPersonEntriesChart(),
        },
        'chart-profession-1': {
          creatorfunc: () => this.createQualificationLevelChart(),
        },
        'chart-profession-2': {
          creatorfunc: () => this.createActivityFieldChart(),
        },
        'chart-profession-3': {
          creatorfunc: () => this.createProfessionTitleChart(),
        },
        'chart-institution-1': {
          creatorfunc: () => this.createInstitutionTypeChart(),
        },
        'chart-institution-2': {
          creatorfunc: () => this.createInstitutionSubtypeChart(),
        },
        'chart-institution-3': {
          creatorfunc: () => this.createInstitutionNameChart(),
        },

        'map-container': {
          creatorfunc: () => {
            console.log("map-container: component id is: ", this.componentid);
            // for the time being, there is an issue with maps, which canno be created multiply
            if (instancecount === 1) {
              return this.createMapchartForLocations()
            }
            else {
              // we create a dummy return value that supports the methods expected
              return {
                render: () => {return {}},
                on: () => {return {}}
              }
            }
          }
        }
      },
    };
  },
  computed: {
    filteredTableData() {
      return filterTableData(this.tableData, this.searchTerm, this.columnVisibility);
    },
    // Filtered table headers based on visibility
    filteredTableHeaders() {
      return this.tableHeaders.filter(header => this.columnVisibility[header.value]);
    }
  },


  methods: {
    toggleInfo() {
      this.isInfoVisible = !this.isInfoVisible;
    },
    countActiveFilter(obj) {
      let count = 0;
      for (let key in obj) {
          if (obj[key].size > 0 || Object.keys(obj[key]).length > 0) {
            count ++;
          }}
          return count;
    },
    chartInfoButtonOnClick(button, textDiv) {
      button.on("click", function() {
        var display = textDiv.style("display");
        textDiv.style("display", display === "none" ? "block" : "none");
      });
    },

    filterOverviewInfoButtonOnClick() {
      var infoButton = d3.select("#infoButton-filter-overview")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "filterOverviewInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#infoButton-filter-overview")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "filterOverviewInfoText")
        .style("display", "none") 
        .text("Um einen Filter zu setzen, klicken Sie bitte auf die Diagramme.");

      infoButton.on("click", function() {
        infoTextDiv.style("display", infoTextDiv.style("display") === "none" ? "block" : "none");
      });
    },
    isLocalFilterActive() {
      return !!Object.keys(this.localFilterState).length;  // Beispielhafte Konvertierung in einen Boolean
    },
    showProfessionChart(chart) {
      this.professionChartShown = chart;
    },
    // text charts
    showProfessionChartTextchart(chart) {
      this.professionChartShownTextchart = chart;
    },
    shownInstitutionChart(chart) {
      this.institutionChartShown = chart;
    },
    showRepositoryChart(chart) {
      this.repositoryChartShown = chart;
    },
    toggleChart(chartID) {
      // check whether the chart has already been created
      console.log('charts-visibility', chartID)

      const chartSelector = "#" + chartID + " svg";
      const chartElement = this.chartsRoot.querySelector(chartSelector);
      console.log("toggleChart(): chartElement: ", chartElement);

      localStorage.setItem(this.componentid + ".chartsVisibility", JSON.stringify(this.chartsVisibility));
      this.updateAllChartsDisplay();

      /*if (!chartElement) {
        // 1. call the creator function for which the chart has been registered - it might either return
        // a single chart or an array of charts
        let chartOrCharts = this.chartsVisibility[chartID].creatorfunc();

        
        if (!Array.isArray(chartOrCharts)) {
          chartOrCharts = [chartOrCharts];
        }
        chartOrCharts.forEach(chart => {
          // 2. set the filtered listener on the chart
          chart.on("filtered", () => this.onChartFiltered());
          // 3. if the creator function cannot call render() at the very end, we might need to call it here
          chart.render();
        })
      }
      localStorage.setItem(this.componentid + ".chartsVisibility", JSON.stringify(this.chartsVisibility));
      this.updateAllChartsDisplay();
    */

    },
    isOpen(chartID) {
      if (this.chartIsOpen[chartID] == true) {
        return chartID
      }
    },
    updateAllChartsDisplay() {
      console.log("updateAllChartsDisplay()");
      // this cannot be done by vue because vue component lifecycle interferes in a hardly controllably with
      // what we do underneath of vue

      // <div v-for="chartId in Object.keys(chartIsOpen).filter(key => chartIsOpen[key])" v-bind:key="chartId">
      //   <div
      //   :id="'chartInfoButton-' + chartId"></div>
      // <div v-html="chartTitlesExpanded[chartId]"></div>
      // <div :id = "chartId" / >
      //     < /div>
      const rootSelector = ".flex-chart-container-events." + this.componentid;
      const root = document.querySelector(rootSelector);
      if (!root) {
        console.log("updateAllChartsDisplay(): root does not exist yet. Do not continue chart display for root selector: ",rootSelector);
        return;
      }
      console.log("updateAllChartsDisplay(), root: ", root);
      root.innerHTML = "";
      console.log("updateAllChartsDisplay(), cleared root: ", root.innerHTML);

      Object.keys(this.chartIsOpen)
          .filter(chartid => this.chartIsOpen[chartid])
          .forEach(chartid => {
            console.log("updateAllChartsDisplay(), will display chart: ", chartid);
            // wrapper for the chart
            const chartCard = document.createElement("div");
            // info button
            const chartInfoButton = document.createElement("div");
            chartInfoButton.id="chartInfoButton-" + chartid;
            chartCard.appendChild(chartInfoButton);
            // title
            const chartTitle = document.createElement("div");
            chartTitle.innerText = this.chartTitlesExtended[chartid];
            chartCard.appendChild(chartTitle);
            // the chart itself - this element will be accessed as parent
            // from within the chart implementations
            const chartRoot = document.createElement("div");
            chartRoot.id = chartid;
            chartRoot.classList.add("expl-chart-root");
            chartCard.appendChild(chartRoot);

            // finally add the card to the display
            root.appendChild(chartCard);

            console.log("updateAllChartsDisplay(): mycharts are: ", this.mycharts);

            // we somehow need to make the charts identifiable if this has not been done already
            const existingChart =
                this.mycharts.filter(chart => chart.chartid == chartid)[0];
            console.log("updateAllChartsDisplay(): found existing chart: ", existingChart);

            if (!existingChart) {
              console.log("updateAllChartsDisplay(): will create a new chart for: ", chartid);
              // 1. call the creator function for which the chart has been registered
              let chartOrCharts = this.chartsVisibility[chartid].creatorfunc();
              console.log("toggleChart(): chartOrCharts: ", chartOrCharts);
              if (!Array.isArray(chartOrCharts)) {
                chartOrCharts = [chartOrCharts];
              }
              chartOrCharts.forEach(chart => {
                // 2. set the filtered listener on the chart
                chart.on("filtered", () => this.onChartFiltered());
                // 3. if the creator function cannot call render() at the very end, we might need to call it here
                console.log("toggleChart(): calling render() on: ", chart);
                chart.render();
                // the domroot attribute which is required for restoring a chart's state
                // is only available in our own chart classes (for textchart) and not in the dc charts
                if (!chart.domroot) {
                  // after rendering, we need to fetch the chart's svg and store it on the chart object
                  chart.domroot = chartRoot.querySelector("svg").parentNode;
                }
                console.log("updateAllChartsDisplay(): found chart's root dom element: ", chart.domroot);
              });
            }
            else {
              console.log("updateAllChartsDisplay(): will reuse and re-attach existing new chart for: ", chartid, existingChart);
              if (!existingChart.domroot) {
                alert("The existing chart to be inserted does not specifiy a domroot attribute!")
              }
              else {
                // charts that have been added before and have not been visible
                // for a while will be updated in the background whenever
                // filter events occur, so we only need to add the chart's domroot element
                // which will contain the updated chart
                chartRoot.appendChild(existingChart.domroot);
              }
            }
          });
    },
    showOrRemoveChartInView(chartID) {
      if (this.chartIsOpen[chartID] == true) {
        console.log('try to remove chart');
        // we do not need to remove the element ourselves because vue will handle this
        // document.getElementById(chartID).parentNode.parentNode.remove();
        this.chartIsOpen[chartID] = false;
        this.updateAllChartsDisplay();
      }
      else {
        this.chartIsOpen[chartID] = true;
        setTimeout(() => {
          // Code to be executed after the delay
          console.log('Action after 2 seconds');
          this.toggleChart(chartID)
        }, 10);
      }
    },
    /*showOrRemoveChartInView(chartID) {
      if (this.chartIsOpen[chartID] == true) {
        document.getElementById(chartID).parentNode.parentNode.remove();
        this.chartIsOpen[chartID] = false;
      }
      else {
        this.chartIsOpen[chartID] = true
        setTimeout(() => {
          // Code to be executed after the delay
          this.toggleChart(chartID)
        }, 10);
      }
    },*/
    // toggleTableVisibility() {
    //   this.isTableVisible = !this.isTableVisible;
    //   localStorage.setItem(this.componentid + ".isTableVisible", JSON.stringify(this.isTableVisible));
    // },
    confirmDownload() {
      confirmDownload(() => this.downloadTableAsCSV());
    },
    downloadTableAsCSV() {
      const csvContent = convertToCSV(this.filteredTableData, this.tableHeaders);
      downloadTableAsCSV(csvContent, "personen_data.csv");
    },
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    toggleColumnVisibility(columnKey) {
      this.columnVisibility[columnKey] = !this.columnVisibility[columnKey];
    },
    closeDropdownOnOutsideClick(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        this.isDropdownVisible = false;
      }
    },
    removeFilters() {
      dc.chartRegistry.list(this.componentid).forEach(chartInRegistry => {
        chartInRegistry.filter(null).render();
      });
      this.renderLocalFiltersView();
      this.externalFilters.forEach(filter => {filter.active = false});
      this.renderExternalFiltersView();
      dc.filterAll(this.componentid);
    },
    extractLocationsFromEvents(events) {
      return Object.values(events
        .filter(evt => evt.latlong.length > 0)
        .reduce((acc, curr) => {
          if (!acc[curr.placeId]) {
            acc[curr.placeId] = {
              placeId: curr.placeId,
              placeLabel: curr.placeLabel,
              latlong: curr.latlong,
              events: {}
            }
          }
          acc[curr.placeId].events[curr.id] = curr;
          return acc;
        }, {}));
    },

    /* start modifying reducer functions as in publications */

    /* reducer functions for calculating groups based on the number of unique events and unique persons */
    createKeyForReducer(dataitem) {
      return "_" + dataitem.type
        + "_" + dataitem.begin
        + "_" + dataitem.placeId
        + "_" + dataitem.protagonistLabel
        + "_" + dataitem.protagonistGender
        + "_" + dataitem.baLvl1
        + "_" + dataitem.baLvl4
        + "_" + dataitem.qualificationLvl
        + "_" + dataitem.reponame
        + "_" + dataitem.repotype
        + "_" + dataitem.institutionLabel
        + "_" + dataitem.institutionTypeLv1
        + "_" + dataitem.institutionTypeLv2
        + "_";
    },
    reduceCountsAdd(acc, curr) {
      // we create keys that concatenate, for each element in the data set, the values
      // of the filter dimensions, we are interested in and use these concatenated strings
      // as keys in the object to be created and manipulated by the reduce functions
      const key = this.createKeyForReducer(curr);

      if (!acc[key]) {
        acc[key] = {
          uniqueEvents: new Set(),
          uniquePersons: new Set(),
          uniqueReponames: new Set()
        }
      }
      acc[key].uniqueEvents.add(curr.id);
      acc[key].uniquePersons.add(curr.protagonistLabel);
      acc[key].uniqueReponames.add(curr.reponame);

      return acc;
    },

    reduceCountsRemove(acc, curr) {
      const key = this.createKeyForReducer(curr);

      acc[key].uniqueEvents.delete(curr.id);
      acc[key].uniquePersons.delete(curr.protagonistLabel);
      acc[key].uniqueReponames.delete(curr.reponame);

      return acc;
    },

    reduceCountsInitial() {
      // console.log("reduceEventIdsInitial()")
      return {}
    },

    /* methods for calculating the numbers given the values created by the reducer functions */
    getEventsCountFromReducedValue(d) {
      return Object.values(d.value)
        .map(val => val.uniqueEvents)
        .reduce((acc, curr) => {
          curr.forEach(el => acc.add(el));
          return acc;
        }, new Set()).size;
    },

    getPersonsCountFromReducedValue(d) {
      return Object.values(d.value)
        .map(val => val.uniquePersons)
        .reduce((acc, curr) => {
          curr.forEach(el => acc.add(el));
          return acc;
        }, new Set()).size;
    },

    getRepositoryCountFromReducedValue(d) {
      return Object.values(d.value)
        .map(val => val.uniqueReponames)
        .reduce((acc, curr) => {
          curr.forEach(el => acc.add(el));
          return acc;
        }, new Set()).size;
    },


    /* methods for creating the charts */

    createMapchartForLocations() {
      var infoButton = d3.select("#chartInfoButton-map-container")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "chartInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#chartInfoButton-map-container")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "chartInfoText")
        .style("display", "none") 
        .text("Die Karte ist zoombar und wirkt wie ein Filter");

      this.chartInfoButtonOnClick(infoButton, infoTextDiv)

      const eventsWithLocations = this.allEvents.filter(event => event.latlong.length > 0);
      console.log("eventsWithLocations: ", eventsWithLocations);
      const locationsWithEvents = this.extractLocationsFromEvents(this.data);
      console.log("locationsWithEvents: ", locationsWithEvents);
      const events2LocationMap = locationsWithEvents.reduce((acc, curr) => {
        Object.keys(curr.events).forEach(evtid => {
          acc[evtid] = curr;
        });
        return acc;
      }, {});

      console.log("events2LocationMap:", events2LocationMap);

      console.log("dcleaflet: ", dcleaflet);
      console.log("L object from leaflet: ", L);

      // currently, dc leatflet gets into big trouble unless there are either NO coordinates
      // or coordinates for ALL data items, so we use antarctica as a dummy...
      const dummyCoordinates = "-73.64717144581896, 42.68994421727224";

      var geodimension = this.cf.dimension(function (d) {
        const loc = events2LocationMap[Number(d.id)];
        if (Number(d.id) % 1 === 0 && loc && loc.latlong) {
          // console.log("found event with location and geocode: ", d, loc, loc.latlong);
          if (loc.latlong.split(",").length === 2) {
            return loc.latlong;
          } else {
            console.log("found invalid coodinates: ", loc.latlong);
            return dummyCoordinates;
          }
        }
        return dummyCoordinates;
      });

      var geodimensionGroup = geodimension.group().reduceCount();

      // in the end, we should not use ids anymore, but classes, because semantics of ids is corrupted
      // as soon as there is more than one tab for events or publications
      const mapContainer = this.chartsRoot.querySelector("#map-container");

      const leafletMarkerChart = new dcleaflet.markerChart(mapContainer);
      console.log("created leafletMarkerChart: ", leafletMarkerChart);
      this.mycharts.push(leafletMarkerChart);

      leafletMarkerChart
        .dimension(geodimension)
        .group(geodimensionGroup)
        .width(600)
        .height(400)
        .renderLabel(true)
        .renderTitle(true)
        .center([42.69, 25.42])
        .zoom(7)
        .cluster(true)
        .filterByArea(true)
          // TODO: trying to handle localFilterState breaks feedback of filter actions on the map to the other charts
          // .on('filtered.localFilterState', function(chart, filter) {
          //   console.log("got filter on map chart: ", chart, filter);
          //   // TODO: here, for the time being we can only add the mere information THAT some custom filtering has been done
          //   //  e.g: mapChart: filtered area
          // })
        .icon(function (d) {
          // for some reason, the Default() icon does not work
          const icon = new L.Icon({
            iconUrl: "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png"
          });
          return icon;
        }
        )

      return leafletMarkerChart;
    },

    createBarChartForGender() {
      var infoButton = d3.select("#chartInfoButton-chart-gender")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "chartInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#chartInfoButton-chart-gender")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "chartInfoText")
        .style("display", "none") 
        .text("Zur Filterung Balken anklicken.");

      this.chartInfoButtonOnClick(infoButton, infoTextDiv)

      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove
      };
      // TODO: for easily resetting the local filters, we can pass
      //  a "localFilterState" object that included information
      //  on the filtered values ("data") and the chart itself ("chart")
      //  the chart property will be set by the chart creator
      //  this.localFilterState.personsByGender = {
      //   data: new Set(),
      //   chart: null
      //  }
      this.localFilterState.personsByGender = new Set();
      console.log('createBarChartForGender chartsRoot', this.chartsRoot.querySelector("#chart-gender"))
      const chart = charts.createBarChart(this.componentid, this.cf,
        this.chartsRoot.querySelector("#chart-gender"),
        "protagonistGender",
        eventReducers,
        this.getPersonsCountFromReducedValue,
        {
          xLabel: "Gender",
          yLabel: "Anzahl Personen"
        },
        { bottom: 50 },
        { filterState: this.localFilterState.personsByGender }
      );
      this.mycharts.push(chart);
      return chart;
    },

    createPieChartForEvents() {
      // chartInfoButton
      var infoButton = d3.select("#chartInfoButton-piechart-for-events")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "chartInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#chartInfoButton-piechart-for-events")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "chartInfoText")
        .style("display", "none") 
        .text("Fahren Sie mit der Maus über ein Tortenstück, um dessen Bezeichnung anzuzeigen. Zur Filterung Tortenstück anklicken.");

      this.chartInfoButtonOnClick(infoButton, infoTextDiv)

      const eventTypeDimension = this.cf.dimension((d) => d.type);
      const eventTypeGroupByeventsCount = eventTypeDimension.group().reduce(this.reduceCountsAdd, this.reduceCountsRemove, this.reduceCountsInitial);
      this.localFilterState.eventByEvents = new Set()

      const chart = charts.createPieChart(this.componentid, 
        this.chartsRoot.querySelector("#piechart-for-events"),
        eventTypeDimension,
        eventTypeGroupByeventsCount,
        this.getEventsCountFromReducedValue,
        { filterState: this.localFilterState.eventByEvents }
      );
      chart.chartid = "piechart-for-events";
      this.mycharts.push(chart);
      return chart;

    },

    createTimelineChartFromEventsWithEventCount() {
      // chartInfoButton
      var infoButton = d3.select("#chartInfoButton-timeline-container-events")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "chartInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#chartInfoButton-timeline-container-events")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "chartInfoText")
        .style("display", "none") 
        .text("Zeiträume können durch Mausnutzung ausgewählt werden.");

      this.chartInfoButtonOnClick(infoButton, infoTextDiv)


      // this array is only used for determining the minData and maxDate
      const eventsWithDate = this.data.filter(evt => evt.begin);

      // the date dimension: we start using single years rather than year intervals
      const dateDimension = this.cf.dimension(event => {
        if (event.begin) {
          return new Date(event.begin, 1, 1);
        }
        else {
          return new Date(2100, 1, 1);
        }
      });

      // the grouping for the date dimension: unique persons and events by year
      const eventsByYearGroup = dateDimension.group()
        .reduce(this.reduceCountsAdd, this.reduceCountsRemove, this.reduceCountsInitial);

      this.localFilterState.timelineByNumberOfEvents = {
        from: null,
        to: null
      };
      const chart = charts.createTimelineChart(this.componentid, 
        this.chartsRoot.querySelector('#timeline-container-events'),
        dateDimension,
        eventsByYearGroup,
        this.getEventsCountFromReducedValue,
        eventsWithDate,
        { filterState: this.localFilterState.timelineByNumberOfEvents }
      );
      chart.chartid = "timeline-container-events";
      this.mycharts.push(chart);
      return chart;
    },

    createBarChartEventsForPersons() {
      var infoButton = d3.select("#chartInfoButton-barchart-events-person")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "chartInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#chartInfoButton-barchart-events-person")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "chartInfoText")
        .style("display", "none") 
        .text("Zur Filterung Balken anklicken.");

      this.chartInfoButtonOnClick(infoButton, infoTextDiv)

      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove
      };
      this.localFilterState.eventsForPersons = new Set()
      const chart = charts.createBarChart(this.componentid, this.cf,
        this.chartsRoot.querySelector("#barchart-events-person"),
        "protagonistLabel",
        eventReducers,
        this.getEventsCountFromReducedValue,
        {
          xLabel: "Personen",
          yLabel: "Anzahl Ereignisse"
        },
        { top: 30, right: 0, bottom: 100, left: 50 },
        { topN: 15, filterState: this.localFilterState.eventsForPersons });
      chart.chartid = "barchart-events-person";
      this.mycharts.push(chart);
      return chart;
    },

    createChartsForReferences() {
      var infoButton = d3.select("#chartInfoButton-repository-charts")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "chartInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#chartInfoButton-repository-charts")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "chartInfoText")
        .style("display", "none") 
        .text("Zur Filterung Balken anklicken.");

      this.chartInfoButtonOnClick(infoButton, infoTextDiv)


      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove
      };

      // TODO: for solving issue #66, we need a separate set for each chart
      //this.localFilterState.referencesEvaluation = new Set()
      this.localFilterState.referencesEvaluationRepositoryTypes = new Set()
      this.localFilterState.referencesEvaluationRepositoryNames = new Set()
      this.localFilterState.referencesEvaluationPersons = new Set()


      const chartContainer1 =  this.chartsRoot.querySelector("#repository-1").appendChild(Object.assign(document.createElement("div"), {id : 'repotypes-by-events-container', className: "dhvis-rotated-ticks"}));
      const chart1 = charts.createBarChart(this.componentid, this.cf,
      chartContainer1,
        "repotype",
        eventReducers,
        this.getEventsCountFromReducedValue,
        { xLabel: "Bestandstyp", yLabel: "Anzahl Ereignisse" },
        { bottom: 100, elasticX: true },
        { filterState: this.localFilterState.referencesEvaluationRepositoryTypes }
      );
      this.mycharts.push(chart1);

      const chartContainer2 =  this.chartsRoot.querySelector("#repository-2").appendChild(Object.assign(document.createElement("div"), {id : 'reponames-by-events-container', className: "dhvis-rotated-ticks"}));
      const chart2 = charts.createBarChart(this.componentid, this.cf,
        chartContainer2,
        "reponame",
        eventReducers,
        this.getEventsCountFromReducedValue,
        {
          xLabel: "Bestand",
          yLabel: "Anzahl Ereignisse"
        },
        { bottom: 200 },
        { topN: 15, filterState: this.localFilterState.referencesEvaluationRepositoryNames }
      );
      this.mycharts.push(chart2);

      const chartContainer3 =  this.chartsRoot.querySelector("#repository-3").appendChild(Object.assign(document.createElement("div"), {id : 'persons-by-reponames-container', className: "dhvis-rotated-ticks"}));
      const chart3 = charts.createBarChart(this.componentid, this.cf,
        chartContainer3,
        "protagonistLabel",
        eventReducers,
        this.getRepositoryCountFromReducedValue,
        {
          xLabel: "Person",
          yLabel: "Anzahl Bestände"
        },
        { bottom: 100 },
        { topN: 15, filterState: this.localFilterState.referencesEvaluationPersons }
      );
      this.mycharts.push(chart3);

      return [chart1, chart2, chart3];
    },

    createChartsForProfessionsEvaluation() {
      var infoButton = d3.select("#chartInfoButton-professions-charts")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "chartInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#chartInfoButton-professions-charts")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "chartInfoText")
        .style("display", "none") 
        .text("Zur Filterung Balken anklicken.");

      this.chartInfoButtonOnClick(infoButton, infoTextDiv)

      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove
      };

      // the value accesor return 0 if the key of the respective data is "" - which is the case
      // if an event does not contain any information regarding professions
      const professionsValueAccessorForPersonsCount = (d) => {
        if (d.key == "") {
          return 0;
        }
        else {
          return this.getPersonsCountFromReducedValue(d);
        }
      };

      //this.localFilterState.professionsEvaluation = new Set()
      this.localFilterState.professionsEvaluationByPersons = new Set()
      this.localFilterState.professionsEvaluationProfessions = new Set()
      this.localFilterState.professionsEvaluationAreas = new Set()

      const chartContainer1 =  this.chartsRoot.querySelector("#profession-1").appendChild(Object.assign(document.createElement("div"), {id : 'ba-quallvl-container', className: "dhvis-rotated-ticks"}));
      const chart1 = charts.createBarChart(this.componentid, this.cf,
        chartContainer1,
        "qualificationLvl",
        eventReducers,
        professionsValueAccessorForPersonsCount,
        {
          xLabel: "Qualifikation",
          yLabel: "Anzahl Personen"
        },
        { bottom: 200 },
        { filterState: this.localFilterState.professionsEvaluationProfessions }
      );
      this.mycharts.push(chart1);

      const chartContainer2 = this.chartsRoot.querySelector("#profession-2").appendChild(Object.assign(document.createElement("div"), {id : 'ba-lvl1-container', className: "dhvis-rotated-ticks"}));
      const chart2 = charts.createBarChart(this.componentid, this.cf,
        chartContainer2,
        "baLvl1",
        eventReducers,
        professionsValueAccessorForPersonsCount,
        {
          xLabel: "Tätigkeitsfelder",
          yLabel: "Anzahl Personen"
        },
        { bottom: 200 },
        { filterState: this.localFilterState.professionsEvaluationAreas }
      );
      this.mycharts.push(chart2);

      const chartContainer3 =  this.chartsRoot.querySelector("#profession-3").appendChild(Object.assign(document.createElement("div"), {id : 'ba-lvl4-container', className: "dhvis-rotated-ticks"}));
      const chart3 = charts.createBarChart(this.componentid, this.cf,
        chartContainer3,
        "baLvl4",
        eventReducers,
        professionsValueAccessorForPersonsCount,
        {
          xLabel: "Berufsbezeichnungen",
          yLabel: "Anzahl Personen"
        },
        { bottom: 200 },
        { topN: 15, filterState: this.localFilterState.professionsEvaluationByPersons}
      );
      this.mycharts.push(chart3);

      return [chart1, chart2, chart3];
    },
    createChartsForInstitutions() {
      var infoButton = d3.select("#chartInfoButton-institutions-charts")
        .append("button")
        .attr("type", "button")
        .attr("id", "infoButton")
        .attr("class", "chartInfoIcon")
        .html("&#9432;");

      // Append a div for the info text
      var infoTextDiv = d3.select("#chartInfoButton-institutions-charts")
        .append("span")
        .attr("id", "infoText")
        .attr("class", "chartInfoText")
        .style("display", "none") 
        .text("Zur Filterung Balken anklicken.");

      this.chartInfoButtonOnClick(infoButton, infoTextDiv)

      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove
      };

      // the value accesor return 0 if the key of the respective data is "" - which is the case
      // if an event does not contain any information regarding professions
      const institutionsValueAccessorForPersonsCount = (d) => {
        if (d.key == "") {
          return 0;
        }
        else {
          return this.getPersonsCountFromReducedValue(d);
        }
      };

      // we might need three different states for the three different dimensions of institutions
      //this.localFilterState.institutionsEvaluation = new Set();
      this.localFilterState.institutionsEvaluationTypes = new Set();
      this.localFilterState.institutionsEvaluationSubtypes = new Set();
      this.localFilterState.institutionsEvaluationByPersons = new Set();

      const chartContainer1 =  this.chartsRoot.querySelector("#institution-1").appendChild(Object.assign(document.createElement("div"), {id : 'inst-lv1-container', className: "dhvis-rotated-ticks"}));
      const chart1 = charts.createBarChart(this.componentid, this.cf,
          chartContainer1,
          "institutionTypeLv1",
          eventReducers,
          institutionsValueAccessorForPersonsCount,
          {
            xLabel: "Institutionstyp",
            yLabel: "Anzahl Personen"
          },
          { bottom: 200 },
          { filterState: this.localFilterState.institutionsEvaluationTypes }
      );
      this.mycharts.push(chart1);

      const chartContainer2 =  this.chartsRoot.querySelector("#institution-2").appendChild(Object.assign(document.createElement("div"), {id : 'inst-lv2-container', className: "dhvis-rotated-ticks"}));
      const chart2 = charts.createBarChart(this.componentid, this.cf,
          chartContainer2,
          "institutionTypeLv2",
          eventReducers,
          institutionsValueAccessorForPersonsCount,
          {
            xLabel: "Untertyp",
            yLabel: "Anzahl Personen"
          },
          { bottom: 200 },
          { filterState: this.localFilterState.institutionsEvaluationSubtypes }
      );
      this.mycharts.push(chart2);

      const chartContainer3 =  this.chartsRoot.querySelector("#institution-3").appendChild(Object.assign(document.createElement("div"), {id : 'inst-names-container', className: "dhvis-rotated-ticks"}));
      const chart3 = charts.createBarChart(this.componentid, this.cf,
          chartContainer3,
          "institutionLabel",
          eventReducers,
          institutionsValueAccessorForPersonsCount,
          {
            xLabel: "Institution",
            yLabel: "Anzahl Personen"
          },
          { bottom: 200 },
          { topN: 15, filterState: this.localFilterState.institutionsEvaluationByPersons}
      );
      this.mycharts.push(chart3);

      return [chart1, chart2, chart3];
    },

    // Textchart
    createDropdownChartForEvents() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };

      const eventTypeDimension = this.cf.dimension((d) => d.type);
      const eventTypeGroup = eventTypeDimension.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );


      const chartId = 'dropdown-for-events';
      const parentSelector = `#${chartId}`;

      this.localFilterState.eventTypeDropdown = new Set();

      const chart = new TextChart(parentSelector)
          .dimension(eventTypeDimension)
          .group(eventTypeGroup)
          .chartGroup(this.chartGroup)
          .valueAccessor((this.getPersonsCountFromReducedValue))
          .filterState(this.localFilterState.eventTypeDropdown)
          .mode(MODE_TEXTINPUT_DROPDOWN_SELECT)
          .hideInactiveItems(true)
          .title("Select Event Types");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;

      this.mycharts.push(chart);
      return chart;
    },

    createTimeIntervalChartForTimeline() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };

      const timelineDimension = this.cf.dimension(pub => {
        return pub.begin && pub.begin !== "null" && !isNaN(pub.begin)
            ? parseInt(pub.begin, 10)
            : 3000; // Default invalid dates
      });

      const timelineGroup = timelineDimension.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId = 'timeinterval-for-events';
      const parentSelector = `#${chartId}`;

      this.localFilterState.timeintervalByNumberOfEvents = new Set();

      const chart = new TextChart(parentSelector)
          .dimension(timelineDimension)
          .group(timelineGroup)
          .chartGroup(this.chartGroup)
          .valueAccessor(d => d.value)
          .filterState(this.localFilterState.timeintervalByNumberOfEvents)
          .mode(MODE_TEXTINPUT_TIME_INTERVAL)
          .title("Select Timeline Interval");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;

      this.mycharts.push(chart);
      return chart;
    },


    createDropdownChartForProfessions() {

      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };
      const professionsValueAccessorForPersonsCount = (d) => {
        if (d.key === "") {
          return 0;
        } else {
          return this.getPersonsCountFromReducedValue(d);
        }
      };

      // Initialize filter states
      this.localFilterState.professionsEvaluationByPersonsTextchart = new Set();
      this.localFilterState.professionsEvaluationProfessionsTextchart = new Set();
      this.localFilterState.professionsEvaluationAreasTextchart = new Set();

      // Chart 1: Qualification Levels
      const professionDimension1 = this.cf.dimension(d => d.qualificationLvl);
      const professionGroup1 = professionDimension1.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId1 = 'profession-textchart-1';
      const parentSelector1 = `#${chartId1}`;
      const chart1 = new TextChart(parentSelector1)
          .dimension(professionDimension1)
          .group(professionGroup1)
          .chartGroup(this.chartGroup)
          .valueAccessor(professionsValueAccessorForPersonsCount)
          .filterState(this.localFilterState.professionsEvaluationProfessionsTextchart)
          .mode(MODE_TEXTINPUT_DROPDOWN_SELECT)
          .title("Select Qualification Levels");

      this.mycharts.push(chart1);

      // Chart 2: Activity Fields
      const professionDimension2 = this.cf.dimension(d => d.baLvl1);
      const professionGroup2 = professionDimension2.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId2 = 'profession-textchart-2';
      const parentSelector2 = `#${chartId2}`;
      const chart2 = new TextChart(parentSelector2)
          .dimension(professionDimension2)
          .group(professionGroup2)
          .chartGroup(this.chartGroup)
          .valueAccessor(professionsValueAccessorForPersonsCount)
          .filterState(this.localFilterState.professionsEvaluationAreasTextchart)
          .mode(MODE_TEXTINPUT_DROPDOWN_SELECT)
          .title("Select Activity Fields");

      this.mycharts.push(chart2);

      // Chart 3: Profession Titles
      const professionDimension3 = this.cf.dimension(d => d.baLvl4);
      const professionGroup3 = professionDimension3.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId3 = 'profession-textchart-3';
      const parentSelector3 = `#${chartId3}`;
      const chart3 = new TextChart(parentSelector3)
          .dimension(professionDimension3)
          .group(professionGroup3)
          .chartGroup(this.chartGroup)
          .valueAccessor(professionsValueAccessorForPersonsCount)
          .filterState(this.localFilterState.professionsEvaluationByPersonsTextchart)
          .mode(MODE_TEXTINPUT_DROPDOWN_SELECT)
          .title("Select Profession Titles");

      this.mycharts.push(chart3);

      // Return the created charts
      return [chart1, chart2, chart3];
    },

    // New Single Chart: chart-repository-1
    createRepositoryTypeChart() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };
      const repositoryValueAccessor = (d) => {
        return this.getEventsCountFromReducedValue(d);
      };

      this.localFilterState.referencesEvaluationRepositoryTypesForTextChart = new Set();

      const dimension = this.cf.dimension(d => d.repotype);
      const group = dimension.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId = 'chart-repository-1';
      const parentSelector = `#${chartId}`;
      const chart = new TextChart(parentSelector)
          .dimension(dimension)
          .group(group)
          .chartGroup(this.chartGroup)
          .valueAccessor(repositoryValueAccessor)
          .filterState(this.localFilterState.referencesEvaluationRepositoryTypesForTextChart)
          .mode(MODE_TEXTINPUT_DROPDOWN_SELECT)
          .title("Quellentypen");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;
      this.mycharts.push(chart);
      return chart;
    },

// New Single Chart: chart-repository-2
    createRepositoryNameChart() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };
      const repositoryValueAccessor = (d) => {
        return this.getEventsCountFromReducedValue(d);
      };

      this.localFilterState.referencesEvaluationRepositoryNamesForTextChart = new Set();

      const dimension = this.cf.dimension(d => d.reponame);
      const group = dimension.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId = 'chart-repository-2';
      const parentSelector = `#${chartId}`;
      const chart = new TextChart(parentSelector)
          .dimension(dimension)
          .group(group)
          .chartGroup(this.chartGroup)
          .valueAccessor(repositoryValueAccessor)
          .filterState(this.localFilterState.referencesEvaluationRepositoryNamesForTextChart)
          .mode(MODE_TEXTINPUT_DROPDOWN_SELECT)
          .title("Quellen");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;
      this.mycharts.push(chart);
      return chart;
    },

// New Single Chart: chart-repository-3
    createRepositoryPersonEntriesChart() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };
      const repositoryValueAccessor = (d) => {
        return this.getEventsCountFromReducedValue(d);
      };


      this.localFilterState.referencesEvaluationPersonsForTextChart = new Set();

      const dimension = this.cf.dimension(d => d.protagonistLabel);
      const group = dimension.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId = 'chart-repository-3';
      const parentSelector = `#${chartId}`;
      const chart = new TextChart(parentSelector)
          .dimension(dimension)
          .group(group)
          .chartGroup(this.chartGroup)
          .valueAccessor(repositoryValueAccessor)
          .filterState(this.localFilterState.referencesEvaluationPersonsForTextChart)
          .mode(MODE_TEXTINPUT_AUTOCOMPLETE)
          .title("Autor*innen");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;
      this.mycharts.push(chart);
      return chart;
    },

    createGenderCheckboxChart() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };

      this.localFilterState.personsByGenderTextchart = new Set();

      const dimension = this.cf.dimension((d) => d.protagonistGender);
      const group = dimension.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId = "checkbox-chart-gender";
      const parentSelector = `#${chartId}`;

      const chart = new TextChart(parentSelector)
          .dimension(dimension)
          .group(group)
          .chartGroup(this.chartGroup)
          .valueAccessor(this.getPersonsCountFromReducedValue)
          .filterState(this.localFilterState.personsByGenderTextchart)
          .mode(MODE_CHECKBOX) // Checkbox selection is embedded in the dropdown mode
          .showSelectButtons(false)
          .title("Gender (Checkbox Mode)");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;
      this.mycharts.push(chart);
      return chart;
    },

    createAutocompleteChartForPlaces() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };

      const dimension = this.cf.dimension(d => d.placeLabel);
      const group = dimension.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId = 'autocomplete-for-places';
      const parentSelector = `#${chartId}`;

      this.localFilterState.placesByPersonenTextchart = new Set();

      const chart = new TextChart(parentSelector)
          .dimension(dimension)
          .group(group)
          .chartGroup(this.chartGroup)
          .valueAccessor(this.getPersonsCountFromReducedValue)
          .filterState(this.localFilterState.placesByPersonenTextchart)
          .mode(MODE_TEXTINPUT_AUTOCOMPLETE)
          .title("Alle Orte");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;

      this.mycharts.push(chart);
      return chart;
    },

    createAutocompleteChartForLiteraryActivity() {
      const dimension = this.cf.dimension(d => d.literariyActivity);
      const group = dimension.group().reduce(
          this.reduceCountsAdd,
          this.reduceCountsRemove,
          this.reduceCountsInitial
      );

      const chartId = 'autocomplete-chart-literaryActivity';
      const parentSelector = `#${chartId}`;

      this.localFilterState.literaryActivityFilter = new Set();

      const chart = new TextChart(parentSelector)
          .dimension(dimension)
          .group(group)
          .chartGroup(this.chartGroup)
          .valueAccessor(this.getPersonsCountFromReducedValue)
          .filterState(this.localFilterState.literaryActivityFilter)
          .mode(MODE_TEXTINPUT_AUTOCOMPLETE)
          .title("Bezeichnung auswählen");

      chart.chartid = chartId;

      chart.onFiltered = () => this.onChartFiltered();

      this.mycharts.push(chart);
      return chart;
    },




// New Single Chart: chart-profession-1
    createQualificationLevelChart() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove
      };
      const professionsValueAccessorForPersonsCount = (d) => {
        if (d.key === "") {
          return 0;
        } else {
          return this.getPersonsCountFromReducedValue(d);
        }
      };

      this.localFilterState.professionsEvaluationProfessionsForTextChart = new Set()

      // Chart 1: Qualification Levels
      const professionDimension1 = this.cf.dimension(d => d.qualificationLvl);
      const professionGroup1 = professionDimension1.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId = 'chart-profession-1';
      const parentSelector1 = `#${chartId}`;
      const chart = new TextChart(parentSelector1)
          .dimension(professionDimension1)
          .group(professionGroup1)
          .chartGroup(this.chartGroup)
          .valueAccessor(professionsValueAccessorForPersonsCount)
          .filterState(this.localFilterState.professionsEvaluationProfessionsForTextChart)
          .mode(MODE_TEXTINPUT_DROPDOWN_SELECT)
          .title("Select Qualification Levels");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;
      this.mycharts.push(chart);
      return chart;
    },

// New Single Chart: chart-profession-2
    createActivityFieldChart() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };
      const professionsValueAccessorForPersonsCount = (d) => {
        if (d.key === "") {
          return 0;
        } else {
          return this.getPersonsCountFromReducedValue(d);
        }
      };

      this.localFilterState.professionsEvaluationAreasForTextChart = new Set();

      const dimension = this.cf.dimension(d => d.baLvl1);
      const group = dimension.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId = 'chart-profession-2';
      const parentSelector = `#${chartId}`;
      const chart = new TextChart(parentSelector)
          .dimension(dimension)
          .group(group)
          .chartGroup(this.chartGroup)
          .valueAccessor(professionsValueAccessorForPersonsCount)
          .filterState(this.localFilterState.professionsEvaluationAreasForTextChart)
          .mode(MODE_TEXTINPUT_DROPDOWN_SELECT)
          .title("Tätigkeitsfelder");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;
      this.mycharts.push(chart);
      return chart;
    },

// New Single Chart: chart-profession-3
    createProfessionTitleChart() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };
      const professionsValueAccessorForPersonsCount = (d) => {
        if (d.key === "") {
          return 0;
        } else {
          return this.getPersonsCountFromReducedValue(d);
        }
      };

      this.localFilterState.professionsEvaluationByPersonsForTextChart = new Set();

      const dimension = this.cf.dimension(d => d.baLvl4);
      const group = dimension.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId = 'chart-profession-3';
      const parentSelector = `#${chartId}`;
      const chart = new TextChart(parentSelector)
          .dimension(dimension)
          .group(group)
          .chartGroup(this.chartGroup)
          .valueAccessor(professionsValueAccessorForPersonsCount)
          .filterState(this.localFilterState.professionsEvaluationByPersonsForTextChart)
          .mode(MODE_TEXTINPUT_DROPDOWN_SELECT)
          .title("Berufsbezeichnungen");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;
      this.mycharts.push(chart);
      return chart;
    },

// New Single Chart: chart-institution-1
    createInstitutionTypeChart() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };
      const institutionsValueAccessorForPersonsCount = (d) => {
        if (d.key == "") {
          return 0;
        } else {
          return this.getPersonsCountFromReducedValue(d);
        }
      };

      this.localFilterState.institutionsEvaluationTypesForTextChart = new Set();

      const dimension = this.cf.dimension(d => d.institutionTypeLv1);
      const group = dimension.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId = 'chart-institution-1';
      const parentSelector = `#${chartId}`;
      const chart = new TextChart(parentSelector)
          .dimension(dimension)
          .group(group)
          .chartGroup(this.chartGroup)
          .valueAccessor(institutionsValueAccessorForPersonsCount)
          .filterState(this.localFilterState.institutionsEvaluationTypesForTextChart)
          .mode(MODE_TEXTINPUT_DROPDOWN_SELECT)
          .title("Institutionstypen");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;
      this.mycharts.push(chart);
      return chart;
    },

// New Single Chart: chart-institution-2
    createInstitutionSubtypeChart() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };
      const institutionsValueAccessorForPersonsCount = (d) => {
        if (d.key == "") {
          return 0;
        } else {
          return this.getPersonsCountFromReducedValue(d);
        }
      };

      this.localFilterState.institutionsEvaluationSubtypesForTextChart = new Set();

      const dimension = this.cf.dimension(d => d.institutionTypeLv2);
      const group = dimension.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId = 'chart-institution-2';
      const parentSelector = `#${chartId}`;
      const chart = new TextChart(parentSelector)
          .dimension(dimension)
          .group(group)
          .chartGroup(this.chartGroup)
          .valueAccessor(institutionsValueAccessorForPersonsCount)
          .filterState(this.localFilterState.institutionsEvaluationSubtypesForTextChart)
          .mode(MODE_TEXTINPUT_DROPDOWN_SELECT)
          .title("Institutionsuntertypen");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;
      this.mycharts.push(chart);
      return chart;
    },

// New Single Chart: chart-institution-3
    createInstitutionNameChart() {
      const eventReducers = {
        reduceCountsInitial: this.reduceCountsInitial,
        reduceCountsAdd: this.reduceCountsAdd,
        reduceCountsRemove: this.reduceCountsRemove,
      };
      const institutionsValueAccessorForPersonsCount = (d) => {
        if (d.key == "") {
          return 0;
        } else {
          return this.getPersonsCountFromReducedValue(d);
        }
      };

      this.localFilterState.institutionsEvaluationByPersonsForTextChart = new Set();

      const dimension = this.cf.dimension(d => d.institutionLabel);
      const group = dimension.group().reduce(
          eventReducers.reduceCountsAdd.bind(this),
          eventReducers.reduceCountsRemove.bind(this),
          eventReducers.reduceCountsInitial.bind(this)
      );

      const chartId = 'chart-institution-3';
      const parentSelector = `#${chartId}`;
      const chart = new TextChart(parentSelector)
          .dimension(dimension)
          .group(group)
          .chartGroup(this.chartGroup)
          .valueAccessor(institutionsValueAccessorForPersonsCount)
          .filterState(this.localFilterState.institutionsEvaluationByPersonsForTextChart)
          .mode(MODE_TEXTINPUT_AUTOCOMPLETE)
          .title("Institutionen");

      chart.onFiltered = () => this.onChartFiltered();
      chart.chartid = chartId;
      this.mycharts.push(chart);
      return chart;
    },

    onChartFiltered() {
      this.currentActivePersons = effunctions.getActivePersons(this.cf);
      // Update data for the tableData
      //this.tableData = JSON.parse(JSON.stringify(this.cf.allFiltered()));
      const filteredData = JSON.parse(JSON.stringify(this.cf.allFiltered()));
      this.tableData = filteredData;


      // once a chart is filtered, we also need to update the local filters view
      this.renderLocalFiltersView();

      console.log("Events: emit filteredPersons", this.localFilterState);
      EventBus.emit('filteredPersons', {
        componentid: this.componentid,
        persons: Array.from(this.currentActivePersons),
        filterState: this.localFilterState
      });

      // filters from events should directly shown on external filter card on publications
      dc.redrawAll(this.chartGroup);

      // Check if the easyDataTable reference is available before calling updatePage
      if (this.$refs.easyDataTable) {
        this.$refs.easyDataTable.updatePage(1);
      }
    //  this.$refs.easyDataTable.updatePage(1)
    },
    removeLocalFilterCard(element, chart) {
    // Remove the parent element (which is the filter card)
    element.parentNode.removeChild(element);
    var filterStateChart = this.filterAttributeToFilterState[chart.split(':')[0].trim()];
    const filterStateToChartRegisterAnchor = this.filterStateToChartRegisterAnchor;

    const mapForBundlesChart = {
        'professionsEvaluation' : ['professionsEvaluationAreas', 'professionsEvaluationProfessions','professionsEvaluationByPersons'],
        'institutionsEvaluation': ['institutionsEvaluationTypes', 'institutionsEvaluationSubtypes', 'institutionsEvaluationByPersons' ],
        'referencesEvaluation': ['referencesEvaluationRepositoryTypes', 'referencesEvaluationRepositoryNames', 'referencesEvaluationPersons' ],
        // text charts
        'professionsEvaluationTextchart' : ['professionsEvaluationAreasTextchart', 'professionsEvaluationProfessionsTextchart','professionsEvaluationByPersonsTextchart'],
    }

    if (!filterStateToChartRegisterAnchor[filterStateChart]) {
      Object.entries(mapForBundlesChart).forEach(([key, value]) => {
        if (value.includes(filterStateChart)) {
            filterStateChart = key;
        }
    });}

    // Update the chart: remove selected filter

    dc.chartRegistry.list(this.componentid).forEach(chartInRegistry => {
      var anchorID = chartInRegistry._anchor.id

      if ((anchorID == filterStateToChartRegisterAnchor[filterStateChart]) || filterStateToChartRegisterAnchor[filterStateChart]?.includes(anchorID)) {
        // it seems that at least for pie charts, re-rendering is required after resetting the filter
        console.log("removeLocalFilterCard(): rendering chart: ", anchorID);
        chartInRegistry.filter(null).render();
        // Update all subcharts in collection
        if (filterStateChart == 'professionsEvaluation' || filterStateChart == 'referencesEvaluation' || filterStateChart == 'institutionsEvaluation' || filterStateChart == 'referencesEvaluationTextchart'){
          filterStateToChartRegisterAnchor[filterStateChart].forEach(subchart => {
            dc.chartRegistry.list(this.componentid).forEach(subchartInRegistry => {
              if (chartInRegistry._anchor.id == subchart) {
                console.log("removeLocalFilterCard(): rendering subchart: ",subchartInRegistry._anchor.id);
                subchartInRegistry.filter(null).render();
              }
            })
          })
        }
      }
    });
    
    if (filterStateChart == 'activeExternalFilters'){
      this.localFilterState.activeExternalFilters = new Set()
      this.externalFilters.forEach(filter => {
        filter.active = !filter.active;
        const applyExternalFiltersArray = effunctions.applyExternalFilters(this.localFilterState, this.externalFilters, this.initialAuthors, this.externalPersonsDimension, this.currentActivePersons, this.cf, this.mycharts, this.componentid);
          this.externalPersonsDimension = applyExternalFiltersArray[0];
          this.currentActivePersons = applyExternalFiltersArray[1];
          filter.updated = false;
          this.renderExternalFiltersView()
      })
    }
    
    // Update apply/remove button of the external filter card
    if (chart.includes('external filter')) {
      const componentIdExternalFilter =  chart.split(':')[1];
      this.externalFilters.forEach(filter => {
        if (filter.componentid == componentIdExternalFilter.trim()) {
          filter.active = false}
      });
    this.renderExternalFiltersView();
    }},
    renderLocalFiltersView() {
      console.log("renderLocalFiltersView() eventView: ", this.localFiltersRoot, this.localFilterState);
      this.localFiltersRoot.innerHTML = "";
      const filterDetailsInfo = document.createElement("div");

      effunctions.collectMetadataFromExternalFilters({ filterState: this.localFilterState }).textContent.split(';').forEach(filter => {
        const divElement = Object.assign(document.createElement("div"), { id: filter});
        // we need to add blanks between the filter values in order to get line breaks
        const pElement = Object.assign(document.createElement("p"), { textContent: (filter || "").replaceAll(",",", ") , className: "local-filter-card"});
        const removeElement = Object.assign(document.createElement("span"), { textContent: 'x', className: "remove-each-local-filter-btn"});

        if (filter.trim() !== "") { // Check if the filter is not empty after trimming whitespaces
          removeElement.addEventListener("click", () => {
            this.removeLocalFilterCard(divElement, filter);
          });
          // TODO: for the time being, we do not display this element
          // divElement.appendChild(removeElement);
          divElement.appendChild(pElement);
          filterDetailsInfo.appendChild(divElement);
        }
      })

      this.localFiltersRoot.appendChild(filterDetailsInfo);
    },
    processExternalFilterEvent(publicationspayload) {
      console.log("processExternalFilterEvent(): ", this.componentid, publicationspayload);

      if (publicationspayload.componentid == this.componentid) {
        console.log("ignore person emitted by ourselves", publicationspayload.componentid, this.componentid);
        return;
      }
      this.pendingFilteredPersonsFromPublication = publicationspayload.persons

      const existingFilterForComponentid = this.externalFilters.filter(fil => fil.componentid === publicationspayload.componentid)[0];
      if (existingFilterForComponentid) {
        console.log("externalFilters: updating existing external filter for componentid ", publicationspayload.componentid, ": ", publicationspayload);
        existingFilterForComponentid.persons = publicationspayload.persons;
        existingFilterForComponentid.updated = true;
      } else {
        this.externalFilters.push({...publicationspayload});
        this.externalFilters[this.externalFilters.length - 1].active = false;
      }
      console.log("processExternalFilterEvent(): external filters is now: ",this.componentid, this.externalFilters);
    },
    renderExternalFiltersView() {
      console.log("renderExternalFiltersView(): ", this.componentid, this.externalFilters);
      // reset
      this.externalFiltersRoot.innerHTML = "";
      // iterate over the filters
      this.externalFilters.forEach(filter => {
        const filterArea = document.createElement("fieldset");
        
        console.log('filter.componentid: ', filter.componentid)
        filterArea.appendChild(Object.assign(document.createElement("legend"), { textContent: filter.componentid}));
        // for transparency, we display the state
        filterArea.appendChild(effunctions.filterStateInfo(filter));

        const elInArea = filterArea.appendChild(Object.assign(document.createElement("div")));
        /// collect metadata from the external filters
        if (filter.filterState) {
          effunctions.collectMetadataFromExternalFilters(filter).textContent.split('; ').forEach(f => {
            elInArea.appendChild(Object.assign(document.createElement("div"), { textContent: f, className: 'div-ext-filters' }));
          })
        }

        // here's the main button - for applying/removing a filter
        console.log('renderExtFilterView filter active', filter)
        const filterMainAction = elInArea.appendChild(Object.assign(document.createElement("button"), { textContent: filter.active ? "Entfernen" : "Anwenden", className: filter.active ? "btn-remove" : "btn-apply" }))

        filterMainAction.onclick = () => {
          filter.active = !filter.active;
          const applyExternalFiltersArray = effunctions.applyExternalFilters(this.localFilterState, this.externalFilters, this.initialAuthors, this.externalPersonsDimension, this.currentActivePersons, this.cf, this.mycharts, this.componentid, this.chartGroup);
          this.externalPersonsDimension = applyExternalFiltersArray[0];
          this.currentActivePersons = applyExternalFiltersArray[1];
          // do what we need to do given the new state of the filter
          // (...)
          // refresh the filters view
          // we remove the updated attribute
          filter.updated = false;
          this.renderExternalFiltersView();
          console.log("renderExternalFilterState(): now calling updateAllChartsDisplay() from click listener on filter", this.componentid, filter);
          this.updateAllChartsDisplay();
          dc.redrawAll(this.chartGroup);

        }
        if (filter.active && filter.updated) {
          // an additional action if a filter is active and has been updated
          const filterAdditionalAction = elInArea.appendChild(Object.assign(document.createElement("button"), { textContent: "Erneut anwenden", className: "btn-apply" }));
          filterAdditionalAction.onclick = () => {
            const applyExternalFiltersArray = effunctions.applyExternalFilters(this.localFilterState, this.externalFilters, this.initialAuthors, this.externalPersonsDimension, this.currentActivePersons, this.cf, this.mycharts, this.componentid, this.chartGroup);
            this.externalPersonsDimension = applyExternalFiltersArray[0];
            this.currentActivePersons = applyExternalFiltersArray[1];
            // do what we need to do, i.e. apply the new filter criteria
            // ... and refresh state+view
            filter.updated = false;
            console.log("renderExternalFilterState(): now calling updateAllChartsDisplay() from given active or updated filter", this.componentid, filter);
            this.renderExternalFiltersView();
            this.updateAllChartsDisplay();
            dc.redrawAll(this.chartGroup);

          }
        }
        // DO NOT FORGET TO ADD THE FILTER AREA TO THE ROOT ELEMENT...
        this.externalFiltersRoot.appendChild(filterArea);
      });

      this.renderLocalFiltersView();

      //Update table
      this.tableData = JSON.parse(JSON.stringify(this.cf.allFiltered()));
      // Check if the easyDataTable reference is available before calling updatePage
      if (this.$refs.easyDataTable) {
        this.$refs.easyDataTable.updatePage(1);
      }
    //  this.$refs.easyDataTable.updatePage(1);
    }
  },
  created() {
    instancecount++;
    this.currentActivePersons = new Set();
    this.componentid = "Biographien-" + instancecount;
    console.log("Events.created(): ", this.componentid);
    this.externalFilters = [];
    this.localFilterState = {};

    window.addEventListener('beforeunload', () => {
      localStorage.setItem(this.componentid + ".chartIsOpen", JSON.stringify(this.chartIsOpen));
    });

    EventBus.on('filteredPersons', (publicationspayload) => {
      this.processExternalFilterEvent(publicationspayload);
      this.renderExternalFiltersView();
    });

  },

  beforeUnmount() {
    console.log("Events.beforeUnmount()", this.componentid);
  },

  unmounted() {
    console.log("Events.unmounted()", this.componentid);
  },

  deactivated() {
    console.log("Events.deactivated(): ", this.componentid);
    this.hasBeenDeactivated = true;
  },

  activated() {
    console.log("Events.activated(): ", this.componentid, this.chartsRoot, this.externalFiltersRoot);
    const loadingLabelSelector = "." + this.componentid + " .loading-label";
    const loadingLabel = document.querySelector(loadingLabelSelector);
    console.log("loadingLabel: ", loadingLabelSelector, loadingLabel);
    if (loadingLabel && !this.data) {
      loadingLabel.classList.add("active");
    }

    const checkInterval = 250;
    const maxWaitime = 60000;
    let actualWaittime = 0;
    const checkDataAvailable = () => {
      if (this.data) {
        if (loadingLabel) {
          loadingLabel.classList.remove("active");
        }
        this.updateAllChartsDisplay();
        this.renderExternalFiltersView();
      }
      else if (actualWaittime > maxWaitime) {
        alert("Ein unbekannter Fehler beim Laden der Daten ist aufgetreten...");
      }
      else {
        actualWaittime += checkInterval;
        setTimeout(() => checkDataAvailable(),checkInterval);
      }
    }
    checkDataAvailable();
  },

  mounted() {
    console.log("Events.mounted(): ", this.componentid, globalEventslog);

    // first of all, try to get a token from the url
    const params = new URLSearchParams(window.location.search)
    const token = params.get("token");

    this.filterOverviewInfoButtonOnClick()

    this.tableRoot = this.$refs.tableRoot;
    this.chartsRoot = this.$refs.chartsRoot;
    this.externalFiltersRoot = this.$refs.externalFiltersRoot;
    this.localFiltersRoot = this.$refs.localFiltersRoot;

    console.log("Events.mounted()", this, this.$refs.chartsRoot);


    const storedState = null;
    if (storedState) {
      this.chartIsOpen = JSON.parse(storedState);
     }
    // const storedTableVisibility = null;
    // if (storedTableVisibility !== null) {
    //   this.isTableVisible = JSON.parse(storedTableVisibility);
    // }

    // given the deployment_mode settings, we now concatenate the url
    const apiAccessUrl = DEPLOYMENT.getApiAccessUrl(DEPLOYMENT.EVENTS_RESOURCE,token);

    console.log("trying to store the external filters that have been set by other components before");

    Object.values(globalEventslog).forEach(eventpayload => this.processExternalFilterEvent(eventpayload));

    console.log("using apiAccessUrl for events: ", apiAccessUrl);

    fetch(apiAccessUrl)
      .then((response) => response.json())
      .then((data, tableData) => {
        this.tableRoot = this.$refs.tableData;
        this.chartsRoot = this.$refs.chartsRoot;

        console.log("repotypes in data: " + Array.from(data.reduce((acc, curr) => {
          acc.add(curr.repotype);
          return acc;
        }, new Set())));

        // we set data as an instance attribute
        this.data = data;

        console.log("data: ", this.data.length);

        this.initialAuthors = this.data.reduce((acc, curr) => {
          acc.add(curr.protagonistLabel);
          return acc;
        }, new Set());
        this.currentActivePersons = this.initialAuthors;


        // Initialize Crossfilter with the fetched data
        this.cf = crossfilter(this.data);

        // Show charts in view when the page is loaded 
        // and charts are open (value 'true' in chartIsOpen map)
        Object.keys(this.chartIsOpen).filter(key => this.chartIsOpen[key]).forEach(key => this.toggleChart(key))

        // Render all charts
        dc.renderAll();
        // Initial table data with unique authors
        this.tableData = this.data;

        // see: https://stackoverflow.com/questions/22392134/is-there-a-way-to-attach-callback-what-fires-whenever-a-crossfilter-dimension-fi
        dc.chartRegistry.list(this.componentid).forEach(chart => {
          if (this.mycharts.indexOf(chart) != -1) {
            console.log("Events: preparing for filtered listening: owner is Events. Set listener", chart);
            chart.on("filtered", () => {
              this.onChartFiltered();
            });
          }
          else {
            console.log("Events: preparing for filtered listening: owner is not Events. Do not set listener", chart);
          }

        });

      });
  },
};
</script>


